var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMockexamimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 532,
    viewBox: "0 0 1500 532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_33)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 532,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.5,
    y: -4.96533,
    width: 122,
    height: 703.777,
    transform: "rotate(35.6912 1070.5 -4.96533)",
    fill: "#018FE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508 -14H1344L1508 217V-14Z",
    fill: "url(#paint0_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508 217.453L1345.5 -14H1315.5L1123 263.151L1319 545H1507.5L1508 217.453Z",
    fill: "url(#paint1_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319 545L1123 263L1046 374.044L1167 545H1319Z",
    fill: "url(#paint2_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.5 -14L1003 93.7959L1124 264L1319 -14H1080.5Z",
    fill: "url(#paint3_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167 545L1046.25 372L925 545H1167Z",
    fill: "url(#paint4_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.31 373L926 200.97L1002.69 93L1123 262.446L1046.31 373Z",
    fill: "url(#paint5_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047 371.997L926.623 201L728 476.13L743.573 532.791L753.62 543H927.438L1047 371.997Z",
    fill: "url(#paint6_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.572 529.395L728.676 478L682 543H754L743.572 529.395Z",
    fill: "#0088DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.721 535L1084 -4H401L0 535H683.721Z",
    fill: "url(#paint7_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 -1H159L0 219.5V534H16.5L401 -1Z",
    fill: "url(#paint8_linear_779_33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 -1H0V219.5L160.5 -1Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.5 199L757.5 -1H561L707.5 469L902.5 199Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_779_33",
    x1: 1547,
    y1: 5.59375,
    x2: 1507.14,
    y2: 107.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_779_33",
    x1: 1543,
    y1: -14,
    x2: 1053.99,
    y2: 388.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_779_33",
    x1: 1182,
    y1: 319.813,
    x2: 837.575,
    y2: 989.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_779_33",
    x1: 1102,
    y1: 160.33,
    x2: 1139.74,
    y2: 47.9722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_779_33",
    x1: 1205.42,
    y1: 175.245,
    x2: 1126.69,
    y2: 619.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_779_33",
    x1: 967.606,
    y1: -104.343,
    x2: 895.548,
    y2: 374.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_779_33",
    x1: 1076,
    y1: 201,
    x2: 772.865,
    y2: 538.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_779_33",
    x1: 250.318,
    y1: 225.713,
    x2: 918.48,
    y2: 247.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_779_33",
    x1: 87,
    y1: 106,
    x2: 244,
    y2: 217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 532,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockexamimage);
export default __webpack_public_path__ + "static/media/Mockexamimage.3f9ab9bfc394971b696734d8b34d83b1.svg";
export { ForwardRef as ReactComponent };